<div class="fixed inset-0 bg-black/10 backdrop-blur-sm z-50" (click)="onClose()"></div>

<div [ngClass]="isMobileView() ? 'bottom-0 right-0 left-0 rounded-t-2xl transform transition-transform duration-300 ease-out' : 'max-w-md w-full rounded-[32px] bottom-8 right-8'"
    class="bg-white dark:bg-dark-secondary shadow-soft p-6 z-50 fixed overflow-y-auto max-h-[90vh]"
    (click)="$event.stopPropagation()" role="dialog" aria-modal="true">

    <!-- Header -->
    <div class="flex justify-between items-center mb-6">
        <div class="flex items-center gap-2">
            <button *ngIf="view === 'change-value'" (click)="onCancelChange()"
                [attr.aria-label]="TEXT.INCOME_MODAL.BACK"
                class="text-gray-500 dark:text-dark-muted hover:text-gray-700 dark:hover:text-white -ml-1">
                <span class="material-symbols-rounded">arrow_back</span>
            </button>
            <h2 class="text-xl font-bold dark:text-dark-text">{{ TEXT.INCOME_MODAL.TITLE }}</h2>
        </div>
        <button (click)="onClose()" class="text-gray-500 dark:text-dark-muted hover:text-gray-700 dark:hover:text-white">
            <span class="material-symbols-rounded">close</span>
        </button>
    </div>

    <!-- Loading state -->
    <div *ngIf="view === 'loading'" class="space-y-4" data-testid="loading-state">
        <p class="text-sm text-gray-600 dark:text-dark-muted">{{ TEXT.INCOME_MODAL.LOADING.MESSAGE }}</p>
        <div class="h-5 w-2/3 rounded-full bg-gray-100 dark:bg-dark-tertiary animate-pulse"></div>
        <div class="h-5 w-1/2 rounded-full bg-gray-100 dark:bg-dark-tertiary animate-pulse"></div>
        <div class="h-5 w-1/3 rounded-full bg-gray-100 dark:bg-dark-tertiary animate-pulse"></div>
        <cta-button [text]="TEXT.INCOME_MODAL.WITH_HISTORY.CONFIRM" theme="primary" width="full" [disabled]="true"></cta-button>
    </div>

    <!-- With-history state -->
    <div *ngIf="view === 'with-history'" class="space-y-5" data-testid="with-history-state">
        <p class="text-sm text-gray-700 dark:text-dark-text">{{ resolvedMessage }}</p>

        <div *ngIf="monthlyBreakdownFormatted.length" class="space-y-1.5 bg-gray-50 dark:bg-dark-tertiary rounded-2xl p-4">
            <div *ngFor="let m of monthlyBreakdownFormatted" class="flex items-center justify-between text-sm">
                <span class="text-gray-500 dark:text-dark-muted capitalize">{{ m.label }}</span>
                <span class="font-medium text-gray-900 dark:text-dark-text">{{ m.amount }}</span>
            </div>
        </div>

        <div class="flex items-start gap-2 text-xs text-gray-500 dark:text-dark-muted">
            <span class="material-symbols-rounded text-sm mt-0.5">lock</span>
            <span>{{ TEXT.INCOME_MODAL.WITH_HISTORY.PRIVACY_NOTE }}</span>
        </div>

        <button type="button" (click)="onChangeValue()"
            class="w-full h-11 rounded-2xl text-sm font-medium text-ocean bg-ocean/10 hover:bg-ocean/20 transition-colors">
            {{ TEXT.INCOME_MODAL.WITH_HISTORY.CHANGE_VALUE }}
        </button>

        <cta-button [text]="TEXT.INCOME_MODAL.WITH_HISTORY.CONFIRM" theme="primary" width="full" (buttonClick)="onConfirm()"></cta-button>
    </div>

    <!-- No-history state -->
    <div *ngIf="view === 'no-history'" class="space-y-4" data-testid="no-history-state">
        <p class="text-sm text-gray-700 dark:text-dark-text">{{ TEXT.INCOME_MODAL.NO_HISTORY.MESSAGE }}</p>

        <div class="space-y-2">
            <label class="text-sm font-medium text-gray-700 dark:text-dark-text">{{ TEXT.INCOME_MODAL.CHANGE_VALUE.LABEL }}</label>
            <div class="relative">
                <span class="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 dark:text-dark-muted text-sm">{{ summary?.currency || 'ARS' }}</span>
                <input #amountInput type="number" min="0.01" step="0.01" [(ngModel)]="amountValue"
                    class="w-full h-12 pl-14 pr-4 border rounded-2xl focus:ring-1 focus:ring-ocean/10 focus:border-ocean outline-none bg-white text-base dark:bg-dark-tertiary border-gray-200 dark:border-dark-border text-gray-900 dark:text-dark-text transition-colors" />
            </div>
            <p *ngIf="saveError" class="text-xs text-danger">{{ saveError }}</p>
            <p *ngIf="!saveError" class="text-xs text-gray-500 dark:text-dark-muted">{{ TEXT.INCOME_MODAL.NO_HISTORY.HELPER }}</p>
        </div>

        <cta-button [text]="isSaving ? '...' : TEXT.INCOME_MODAL.CHANGE_VALUE.SAVE" theme="primary" width="full"
            [disabled]="!isAmountValid || isSaving" (buttonClick)="onSave()"></cta-button>
    </div>

    <!-- Change-value state -->
    <div *ngIf="view === 'change-value'" class="space-y-4" data-testid="change-value-state">
        <div class="space-y-2">
            <label class="text-sm font-medium text-gray-700 dark:text-dark-text">{{ TEXT.INCOME_MODAL.CHANGE_VALUE.LABEL }}</label>
            <div class="relative">
                <span class="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 dark:text-dark-muted text-sm">{{ summary?.currency || 'ARS' }}</span>
                <input #amountInput type="number" min="0.01" step="0.01" [(ngModel)]="amountValue"
                    class="w-full h-12 pl-14 pr-4 border rounded-2xl focus:ring-1 focus:ring-ocean/10 focus:border-ocean outline-none bg-white text-base dark:bg-dark-tertiary border-gray-200 dark:border-dark-border text-gray-900 dark:text-dark-text transition-colors" />
            </div>
            <p *ngIf="saveError" class="text-xs text-danger">{{ saveError }}</p>
        </div>

        <div class="flex gap-3">
            <button type="button" (click)="onCancelChange()"
                class="flex-1 h-12 rounded-2xl text-sm font-medium text-gray-700 dark:text-dark-text bg-gray-100 dark:bg-dark-tertiary hover:bg-gray-200 dark:hover:bg-dark-border transition-colors">
                {{ TEXT.INCOME_MODAL.CHANGE_VALUE.CANCEL }}
            </button>
            <cta-button class="flex-1" [text]="isSaving ? '...' : TEXT.INCOME_MODAL.CHANGE_VALUE.SAVE" theme="primary" width="full"
                [disabled]="!isAmountValid || isSaving" (buttonClick)="onSave()"></cta-button>
        </div>
    </div>
</div>
